import React from 'react'
import MenuItem from './MenuItem'
import includes from 'lodash/includes'

const Sidebar = ({ location, role, menus, branch }) => (
  <div>
    <nav className='sidebar'>
      <div className='sidebar-container'>
        <div className='sidebar-header'>
          <div className='brand'>
            {
              role === 'admin_travy'
                ? <p>Travelinpod <strong>Admin</strong></p>
                : <p>Passpod { branch === 'PH' && 'PH' } <strong>Admin</strong></p>
            }
          </div>
        </div>
        <nav className='menu'>
          <ul className='sidebar-menu metismenu' id='sidebar-menu'>
            {
              menus.map((menu, i) => {
                if ((includes(menu.role, role) && (includes(menu.branch, branch)))) {
                  return <MenuItem key={i} menu={menu} location={location} role={role} branch={branch} />
                } else {
                  return null
                }
              })
            }
          </ul>
        </nav>
      </div>
    </nav>
    <div className='sidebar-overlay' id='sidebar-overlay' />
    <div className='sidebar-mobile-menu-handle' id='sidebar-mobile-menu-handle' />
    <div className='mobile-menu-handle' />
  </div>
)

export default Sidebar



// WEBPACK FOOTER //
// ./src/Components/Nav/Sidebar.js